import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { AiChatFormComponent } from './ai-chat-form.component';
import { AiChatFormDialogData } from './ai-chat.types';

@Injectable()
export class AiChatFormDialog {
  #dialog = inject(DialogService);
  /** Portal parent injector so `AiChatFormService` resolves (not root). */
  #parentInjector = inject(Injector);

  open(data?: AiChatFormDialogData): DialogRef {
    return this.#dialog.open(AiChatFormComponent, data, {
      parentInjector: this.#parentInjector,
    });
  }
}
